import React from "react";
import { SensorDataFile } from "@shared/models";

import "./index.scss";
import { SensorDataSessionFilesItem } from "./components";

interface SensorDataSessionFilesListProps {
  files: SensorDataFile[];
}

const SensorDataSessionFilesList = (props: SensorDataSessionFilesListProps) => {
  const { files } = props;
  return (
    <div className="sensor-data-session-files">
      {files.map((file) => (
        <SensorDataSessionFilesItem key={file.id} file={file} />
      ))}
    </div>
  );
};

export default SensorDataSessionFilesList;
